export enum RatingSize {
  LARGE = 'large',
  MEDIUM = 'medium',
  SMALL = 'small',
}
